var collectionFilterOps = {
  section_id: 'template--20101451088179__ba268f1a-2fd3-491c-a290-b6aa3293409b',
  nowPage: 1,
  maxPage: 1,
  changeUrl: function (params = "") {
    if (params) {
      history.replaceState(
        {
          page: 0,
        },
        "1.html",
        "?" + params
      );
    } else {
      history.replaceState({ page: 0, }, "1.html", '?');
    }
  },
  bind: function () {
    let that = this;
    let _t = false;
    let _timer = null;
    // 界面移动效果
    $(window).scroll(function (e) {
      // 超出下一页时
      if (that.nowPage >= that.maxPage) return;
      // 正在执行时
      if (_t) return;
      let _cHeight = $(".CollectionProduct").offset().top + $(".CollectionProduct").height() - $(".CollectionProduct>*:last-child").height() * 2;
      // 移动超过两个产品高度时执行
      if (e.currentTarget.pageYOffset < _cHeight) return;
      if (_timer) { clearTimeout(_timer) };

      // 正式执行加载下一页
      $('.CollectionProduct').addClass('next_load')
      _timer = setTimeout(() => {
        _t = true;
        let params = $.map(decodeURI(location.href.split("?")[1]).split("&"), (item) => {
          if (item.indexOf("filter.") == -1) return;
          return item
        });
        that.getParams(params + (params ? '&' : '') + 'page=' + (that.nowPage + 1)).then(() => {
          $('.CollectionProduct').removeClass('next_load')
          _t = false;
        })
      })
    });
    // 筛选弹窗绑定
    that.filterRun();
  },
  getParams: function (params = "") {
    let that = this;
    params = encodeURI(params)
    that.changeUrl(params);
    let url = location.pathname + "?" + params + (params ? '&' : '') + 'section_id=' + that.section_id;
    // 获取源代码
    return $.AjaxPromise({
      url: url,
    }).then(html => {
      // 每页执行代码
      that.maxPage = parseInt($(html).find(".CollectionProduct").attr("maxPage"));
      that.nowPage = parseInt($(html).find(".CollectionProduct").attr("nowPage"));

      // pc 左边的 点击效果
      $(".CollectionInfo .LeftDiv").html("").append($(html).find('.CollectionInfo .LeftDiv'));
      // 手机端 弹窗
      $(".CollectionInfo .mobile_pc .filterBody").html("").append($(html).find(".CollectionInfo .mobile_pc .filterBody>*"));
      that.filterRun();

      // 清空产品 或 向后添加产品
      let productItems = $(html).find(".CollectionProduct>*");
      if (that.nowPage == 1) {
        $(".CollectionProduct>li").remove();
      }
      $.map(productItems, (item) => {
        $(".CollectionProduct").append(item);
      });

    })
  },
  filterRun: function () {
    let that = this;
    // pc 左边点击绑定
    $(".CollectionInfo .pc_mobile .FilterInfo input").unbind("click").click(function () {
      let _that = this;
      let name = $(_that).attr("name");
      let value = $(_that).attr("value").replaceAll(" ", '+');
      // 生成访问参数
      let params = $.map(decodeURI(location.href.split("?")[1]).split("&"), (item) => {
        if (item.indexOf("filter.") == -1) return;
        return item
      });
      let key = name + "=" + value
      if (!_that.checked) {
        params = $.map(params, (item) => {
          if (item != key) {
            return item
          }
        })
      } else {
        if (params.indexOf(key) == -1) {
          params.push(key)
        }
      }
      $('.CollectionLoad').addClass('loading')
      params = params.join("&")
      that.changeUrl(encodeURI(params))
      if (that.GetTime) {
        clearTimeout(that.GetTime);
      }
      $('html,body').animate({scrollTop: ($(".CollectionInfo").offset().top - 10)+'px'}, 500);
      that.GetTime = setTimeout(() => {
        that.getParams(params + (params ? '&' : '') + 'page=1').then(() => {
          $('.CollectionLoad').removeClass('loading')
        })
      }, 1500);

    })
    // 手机端清空按钮
    $(".CollectionInfo .filterBottom .clearBtn").unbind("click").click(function () {
      $('html,body').animate({scrollTop: ($(".CollectionInfo").offset().top - 10)+'px'}, 500);
      that.clearUrl();
      $(".CollectionInfo .TopDiv").removeClass("active");
    });
    // 手机端生效按钮
    $(".CollectionInfo .filterBottom .appleBtn").unbind("click").click(function () {
      let params = $.map($(".CollectionInfo .mobile_pc input[type='checkbox']:checked"), function (item) {
        let name = $(item).attr("name");
        let value = $(item).attr("value").replaceAll(" ", '+');
        return name + '=' + value
      }).join("&");
      $(".CollectionInfo .TopDiv").removeClass("active");
      $('.CollectionLoad').addClass('loading')
      that.changeUrl(encodeURI(params))
      if (that.GetTime) {
        clearTimeout(that.GetTime);
      }
      $('html,body').animate({scrollTop: ($(".CollectionInfo").offset().top - 10)+'px'}, 500);
      that.GetTime = setTimeout(() => {
        that.getParams(params + (params ? '&' : '') + 'page=1').then(() => {
          $('.CollectionLoad').removeClass('loading')
        })
      }, 1500);
    });

    // 手机端其他点击效果
    $('.FilterClick').unbind("click").click(function () {
      $('.FilterPopup').addClass('active')
    })
    $('.FilterPopup .Close').unbind("click").click(function () {
      $('.FilterPopup').removeClass('active')
    })
    $('.FilterInfo p').unbind("click").click(function () {
      if ($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active')
      } else {
        $(this).parent().addClass('active')
      }
    })

  },
  clearUrl: function () {
    let that = this;
    $('.CollectionLoad').addClass('loading')
    return that.getParams().then(() => {
      $('.CollectionLoad').removeClass('loading')
    })
  },
}
$(function () {
  collectionFilterOps.section_id = "template" + $(".CollectionInfo").parent().attr("id").split("template")[1];
  collectionFilterOps.maxPage = parseInt($(".CollectionProduct").attr("maxPage"));
  collectionFilterOps.nowPage = parseInt($(".CollectionProduct").attr("nowPage"));
  collectionFilterOps.bind();
})